// Use an HTTP attachment, not a blob: URL. Some embedded browsers create an
// empty local file when a page-owned blob is handed to their download manager.
export async function downloadStudyPdf({ base, revision, preview, part, token, onError = () => {} }) {
  const response = await fetch(`${base}/pdf-download-ticket`, {
    method: 'POST', cache: 'no-store',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ revision, preview: !!preview, ...(part === undefined ? {} : { part }) }),
  });
  const body = await response.json();
  if (!response.ok || !body.success) throw new Error(body.message || 'Préparation du téléchargement impossible.');
  if (!/^[a-f0-9]{64}$/.test(body.ticket || '')) throw new Error('Autorisation de téléchargement invalide.');

  const frame = document.createElement('iframe');
  frame.name = `ircc-download-${body.ticket.slice(0, 16)}`;
  frame.title = 'Téléchargement du formulaire IRCC';
  frame.hidden = true;
  const form = document.createElement('form');
  form.method = 'POST'; form.action = `${base}/pdf-download`;
  form.target = frame.name; form.hidden = true;
  const input = document.createElement('input');
  input.type = 'hidden'; input.name = 'download_ticket'; input.value = body.ticket;
  form.appendChild(input);
  let timer;
  const cleanup = () => { clearTimeout(timer); form.remove(); frame.remove(); };
  frame.onload = () => {
    try {
      const message = frame.contentDocument?.body?.textContent;
      if (message?.trim().startsWith('{')) {
        const error = JSON.parse(message);
        if (error.success === false) { onError(error.message || 'Téléchargement impossible.'); cleanup(); }
      }
    } catch (_) { /* A cross-origin attachment is handled by the browser. */ }
  };
  document.body.appendChild(frame); document.body.appendChild(form);
  try {
    // Keep the target alive while the native download manager receives the file.
    timer = setTimeout(cleanup, 300000);
    form.submit();
  } catch (error) { cleanup(); throw error; }
}
